// Auto generated file, do not manually modify!
// com.hotpads.satellite.web.api.web.renter.v1.SatelliteWebRenterWarningsHandler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  SatelliteWebRenterWarningsHandler_getUserWarnings,
  SatelliteWebRenterWarningsHandler_getUserWarnings_Path,
} from '@zg-rentals/ts-satellite-client';

import type { SatelliteWebRenterUserWarningsResponseDto } from '@zg-rentals/ts-satellite-client';

export type SatelliteWebRenterWarningsHandler_getUserWarnings_Options = UseQueryOptions<
  SatelliteWebRenterUserWarningsResponseDto,
  unknown,
  SatelliteWebRenterUserWarningsResponseDto,
  readonly [string]
>;

const SatelliteWebRenterWarningsHandler_getUserWarnings_GetKey = () =>
  [SatelliteWebRenterWarningsHandler_getUserWarnings_Path] as const;

export const SatelliteWebRenterWarningsHandler_getUserWarnings_queryOptions = ({
  httpClient,
}: { httpClient?: Client } = {}) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: SatelliteWebRenterWarningsHandler_getUserWarnings_GetKey(),
    queryFn: () => SatelliteWebRenterWarningsHandler_getUserWarnings(httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get user warnings for personal contact details and external links
 */
export const useSatelliteWebRenterWarningsHandler_getUserWarnings = ({
  httpClient,
  ...options
}: Omit<SatelliteWebRenterWarningsHandler_getUserWarnings_Options, 'queryFn' | 'queryKey'> & {
  httpClient?: Client;
} = {}) => {
  return useQuery({
    ...SatelliteWebRenterWarningsHandler_getUserWarnings_queryOptions({ httpClient }),
    ...options,
  });
};
useSatelliteWebRenterWarningsHandler_getUserWarnings.getKey = SatelliteWebRenterWarningsHandler_getUserWarnings_GetKey;
